import { ScrollCtrl } from '../controllers/ScrollCtrl';
import { Module } from '../Module';

Module.instance().directive('tbScroll',
  () => {
    return {
      restrict: 'E',
      replace: true,
      transclude: true,
      templateUrl: 'scrolling.html',
      scope: {
        items: '=',
        layout: '=',
        sliceChanged: '&',
        scrollControls: '=?',
        scrollLeftChanged: '&'
      },
      controller: ScrollCtrl
    };
  }
);

Module.instance().directive('tbScrollContentArea',
  () => {
    return {
      require: '^tbScroll',
      link: (scope: ng.IScope, element: JQuery, attributes: ng.IAttributes, scrollCtrl: ScrollCtrl) => {
        scrollCtrl.contentArea = element;
      }
    };
  }
);

Module.instance().directive('tbScrollContent',
  () => {
    return {
      require: '^tbScroll',
      link: (scope: ng.IScope, element: JQuery, attributes: ng.IAttributes, scrollCtrl: ScrollCtrl) => {
        scrollCtrl.content = element;
      }
    };
  }
);
